// OTP Phone actions

import * as types from './actionTypes';
import { notifySuccess } from './notificationActions';
import * as consumerApi from '../../services/consumerApi';
import { dialogLoading, dialogClose, dialogError } from './dialogActions';
import { executeConsumerGet } from './profileActions';

function getMarket(state) {
    return state?.auth?.user?.market;
}

export function otpPhoneReset() {
    return { type: types.OTP_PHONE_RESET };
}

export function otpPhoneSetToken(token) {
    return { type: types.OTP_PHONE_SET_TOKEN, token };
}

export function executeSendOtp(params) {
    return function (dispatch, getState) {
        const country = getMarket(getState());
        return Promise.resolve()
            .then(() => {
                if (!params) throw new Error();
            })
            .then(() => dispatch(dialogLoading()))
            .then(() => consumerApi.updateOtpPhoneNumber(country, params))
            .then((result) => {
                dispatch(dialogLoading(false));
                dispatch(otpPhoneSetToken(result?.data?.vToken));
                dispatch(notifySuccess((L) => L.msg_otp_phone_send_code_ok));
            })
            .catch((error) => {
                dispatch(dialogLoading(false));
                dispatch(dialogError(error));
            });
    };
}

export function executeVerifyOtp(params) {
    return function (dispatch, getState) {
        const country = getMarket(getState());
        return Promise.resolve()
            .then(() => {
                if (!params) throw new Error();
            })
            .then(() => dispatch(dialogLoading()))
            .then(() => consumerApi.updateOtpPhoneNumberVerify(country, params))
            .then(() => {
                dispatch(dialogClose());
                dispatch(otpPhoneReset());
                dispatch(notifySuccess((L) => L.msg_otp_phone_verify_code_ok));
                dispatch(executeConsumerGet(params.consumerId, true));
            })
            .catch((error) => {
                dispatch(dialogLoading(false));
                dispatch(dialogError(error));
            });
    };
}
